import { Router } from '@angular/router';
import { Auth } from './../../../autentication/Auth';
import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TweenMax, Quint } from 'gsap';
import { InvestmentsSimulationEventType } from './investments-simulation.event.type';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { EventTypes } from '../../../shared/EventTypes';
import { Simulation } from '../models/simulation';

@Component({
	selector: 'app-investments-simulation',
	templateUrl: './investments-simulation.component.html',
	styleUrls: ['./investments-simulation.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class InvestmentsSimulationComponent implements OnInit, OnDestroy {

	private showBalance = true;
	private canSend = false;
	public form: FormGroup;
	private firedError = false;
	public flow: Array<string> = [
		InvestmentsSimulationEventType.SEND.INVEST_SEND,
		InvestmentsSimulationEventType.SEND.INVESTMENTS_CONFIRMATION_SEND
	];
	public flowIndex = 0;
	public flowInvestimentsConfirmationSend: string = InvestmentsSimulationEventType.SEND.INVESTMENTS_CONFIRMATION_SEND;
	public simulationData = new Simulation();
	public hasSubmited = false;
	public activeBackButton = false;
	public showStepButtons = false;

	title = 'Simular Investimentos';
	subtitle = 'Simule e contrate o melhor investimento para você';

	onSetTitleSubtitle(data) {
		this.title = data.title;
		this.subtitle = data.subtitle;
	}

	constructor(private router: Router) { }

	ngOnInit() {
		// Animacao inicial para exibir a etapa de inicio
		TweenMax.delayedCall(.3, () => {
			AppEventDispatcher.dispatch(InvestmentsSimulationEventType.STEPS.INVEST, { show: true });
			if (this.showBalance) {
				AppEventDispatcher.dispatch(EventTypes.BALANCE, {show: true});
			}
		});

		AppEventDispatcher.listen(InvestmentsSimulationEventType.ACTIONS.BUTTONS, data => {

			TweenMax.to('.buttons', .8, {bottom: '-100%', ease: Quint.easeOut});
			TweenMax.delayedCall(.6, () => {
				this.activeBackButton = true;

				TweenMax.delayedCall(.2, () => {
					TweenMax.to('.buttons', .8, {bottom: 0, ease: Quint.easeOut});
				});
			});

		});

		const own = this;
		AppEventDispatcher.listen(InvestmentsSimulationEventType.ERROR, (data): any => {
			own.firedError = true;

			own.flowIndex = own.flow.findIndex((item, index, array) => {
				if (item === data.step) {
					return true;
				} else {
					return false;
				}
			});

		AppEventDispatcher.listen(InvestmentsSimulationEventType.STEPS.INVESTMENTS_SUMMARY, data => {
			this.showStepButtons = true;
		});

			own.canSend = true;
		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(InvestmentsSimulationEventType.ACTIONS.BUTTONS);
		AppEventDispatcher.removeListener(InvestmentsSimulationEventType.ERROR);
		AppEventDispatcher.removeListener(InvestmentsSimulationEventType.STEPS.INVESTMENTS_SUMMARY);
	}

	// Executa essa funcao quando a atapa atual for exibida
	onSetForm(form: FormGroup) {
		this.form = form; // Recebe o form da etapa atual
		this.canSend = true;
	}

	// Dispara o evento da etapa atual para esconder e dispara o da proxima etapa para exibir
	sendForm(event) {
		this.hasSubmited = true;
		AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { hide: true });

		if (this.form.valid && this.canSend) {
			this.canSend = false;
			AppEventDispatcher.dispatch(this.flow[this.flowIndex], null);
			this.hasSubmited = false;

			if (this.firedError) {
				this.firedError = false;
				return;
			}
			this.flowIndex++;
		}
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/investments/investments-simulation/investments-simulation.component.ts